import { ReactComponent as InfoCircle } from '@/assets/svgs/info-circle.svg';
import Button from '@/components/Button/index';
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import rem from "@/utils/rem";
import { feature } from "@/utils/feature-verifier.js";
import { featureConstant } from "@/constants/configuration/feature.js";

const AgentPrincipalInformationModal = ({ visible, hide, show }) => {

	const modalHeaderText = feature(featureConstant.AGENT_PRINCIPAL_PHASE_2) ? "Enable Agent Principal" : "Enrolled as Agent to consume for Principal";
	const modalBodyText = feature(featureConstant.AGENT_PRINCIPAL_PHASE_2) ? "By enabling this function, you will be granted access to provide or consume data on behalf of organisations that have not yet joined the SGTraDex platform. You are required to provide the organization's company name and UEN for which you intend to provide or consume data on behalf." : "By enabling this function, you are allowed to consume data for company that is not onboarded to SGTraDex. You are required to provide the principal's company name and UEN. You can select the principal to initiate data request to the contributor.";

	return (
		<Modal visible={visible} variant='medium' close={hide}>
			<CardConfigure addHeaderClass="eap-modal__header" >
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__rounded-square'}>
										<div className='tnc-modal__icon'>
											<InfoCircle />
										</div>
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										{modalHeaderText}
									</div>

								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="eap-modal__content center">
							{modalBodyText}
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button full maxWidth="100" submit={() => hide()} text="Okay, got it!" />
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}

export default AgentPrincipalInformationModal;
